//-----------------------------------------------
// HTML/Uploaded Videos
//-----------------------------------------------

function uploadedVideoPlaceholders() {
	const placeholders = document.querySelectorAll(".html-video--placeholder");
	if (placeholders.length < 1) return;
	placeholders.forEach((placeholder) => {
		const videoWrap = placeholder.querySelector(".video__video-wrap");
		const mobileVideo = placeholder.querySelector(".video__video--mobile");
		const video = placeholder.querySelector(
			".video__video:not(.video__video--mobile)",
		);
		const play = placeholder.querySelector(".video-play-button");
		const overlay = placeholder.querySelector(".video__overlay");
		const playVideo = (e) => {
			e.preventDefault();
			videoWrap.classList.add("playing");
			if (mobileVideo && window.innerWidth < 769) {
				mobileVideo.play();
			} else {
				video.play();
			}
		};
		play.addEventListener("click", playVideo);
		overlay?.addEventListener("click", playVideo);
		video.addEventListener("ended", (e) => {
			setTimeout(() => {
				videoWrap.classList.remove("playing");
			}, 500);
		});
	});
}

uploadedVideoPlaceholders();

//-----------------------------------------------
// Lazy third-party player APIs
//
// The Vimeo and YouTube player APIs are no longer enqueued globally in
// enqueue-scripts.php. They are injected here, once, only when a page
// actually needs them (an embed scrolled near the viewport or clicked).
//-----------------------------------------------

var vimeoApiPromise = null;
function loadVimeoApi() {
	if (window.Vimeo && window.Vimeo.Player) {
		return Promise.resolve();
	}
	if (!vimeoApiPromise) {
		vimeoApiPromise = new Promise(function (resolve, reject) {
			var script = document.createElement("script");
			script.src = "https://player.vimeo.com/api/player.js";
			script.async = true;
			script.onload = resolve;
			script.onerror = reject;
			document.head.appendChild(script);
		});
	}
	return vimeoApiPromise;
}

var youtubeApiPromise = null;
function loadYouTubeApi() {
	if (window.YT && window.YT.Player) {
		return Promise.resolve();
	}
	if (!youtubeApiPromise) {
		youtubeApiPromise = new Promise(function (resolve) {
			window.onYouTubeIframeAPIReady = resolve;
			var script = document.createElement("script");
			script.src = "https://www.youtube.com/player_api";
			script.async = true;
			document.head.appendChild(script);
		});
	}
	return youtubeApiPromise;
}

function observeOnce(el, callback) {
	if (!("IntersectionObserver" in window)) {
		callback();
		return;
	}
	var observer = new IntersectionObserver(
		function (entries) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting) return;
				observer.disconnect();
				callback();
			});
		},
		{ rootMargin: "200px 0px" },
	);
	observer.observe(el);
}

var video_embeds = document.querySelectorAll(".video-embed");
if (video_embeds.length > 0) {
	var videos = {};

	// Nodelist to array to use forEach();
	var videos_array = [].slice.call(video_embeds);

	videos_array.forEach(function (e, i) {
		// element, incrementor
		videos[i] = {};
		videos[i]["parent"] = e;
		videos[i]["video_id"] = e.dataset.videoId;
		videos[i]["service"] = e.dataset.service;
		videos[i]["video_container"] = e.querySelector(".video-container");
		videos[i]["video_container_parent"] =
			e.querySelector(".video-container").parentNode;
		videos[i]["play_button"] = e.querySelector(".video-play-button");
		videos[i]["background_toggle"] = e.querySelector(
			".background-video__toggle",
		);
		videos[i]["background_mute"] = e.querySelector(".background-video__mute");
		videos[i]["overlay"] = e.querySelector(".video__overlay");
		videos[i]["muted_preview"] = e.dataset.mutedPreview === "true";

		// Create the player (and load the API) the first time it is needed.
		var ensurePlayer = function () {
			if (videos[i].player) {
				return Promise.resolve(videos[i].player);
			}
			if (videos[i].creating) {
				return videos[i].creating;
			}
			if (videos[i].service == "vimeo") {
				videos[i].creating = loadVimeoApi().then(function () {
					return createAndWireVimeoPlayer(i);
				});
			} else if (videos[i].service == "youtube") {
				videos[i].creating = loadYouTubeApi().then(function () {
					return createAndWireYouTubePlayer(i);
				});
			} else {
				videos[i].creating = Promise.resolve(null);
			}
			return videos[i].creating;
		};

		var playVideo = function (event) {
			event.preventDefault();
			videos[i].parent.classList.add("is-playing");
			videos[i].video_container.style.opacity = 1;
			videos[i].video_container.style.pointerEvents = "auto";
			if (videos[i].service == "upload") {
				videos[i].video_file_el =
					videos[i].video_container.querySelector(".video-el");
				videos[i].video_file_el.play();
				videos[i].video_file_el.addEventListener(
					"ended",
					(event) => {
						resetVideoContainer(i);
					},
				);
				return;
			}
			if (
				videos[i].service == "vimeo" &&
				videos[i].muted_preview &&
				!videos[i].player &&
				!videos[i].creating
			) {
				// Clicked before the muted preview player was created — skip the
				// preview and build the full player directly.
				videos[i].muted_preview = false;
				loadVimeoApi().then(function () {
					videos[i].player = replaceVimeoPlayer(videos[i]);
					videos[i].player.on("ended", function (data) {
						resetVideoContainer(i);
					});
					playVimeoFromStart(videos[i].player);
				});
				return;
			}
			ensurePlayer().then(function () {
				if (videos[i].service == "vimeo") {
					if (videos[i].muted_preview) {
						videos[i].muted_preview = false;
						videos[i].player = replaceVimeoPlayer(videos[i]);
						videos[i].player.on("ended", function (data) {
							resetVideoContainer(i);
						});
						playVimeoFromStart(videos[i].player);
					} else {
						videos[i].player.play();
					}
				} else if (videos[i].service == "youtube") {
					videos[i].player.playVideo();
				}
			});
		};
		if (videos[i].play_button) {
			videos[i].play_button.addEventListener("click", playVideo);
		}
		if (videos[i].overlay) {
			videos[i].overlay.addEventListener("click", playVideo);
		}

		// Create players when the embed nears the viewport rather than at page
		// load, so third-party player assets never block or compete with the
		// initial page load. The click handler above covers the rare case of a
		// click landing before the observer has created the player.
		if (videos[i].service === "vimeo" || videos[i].service === "youtube") {
			observeOnce(videos[i].parent, ensurePlayer);
		}
	});
}

function createAndWireVimeoPlayer(i) {
	videos[i].player = createVimeoPlayer(videos[i], videos[i].muted_preview);
	videos[i].player.on("ended", function (data) {
		resetVideoContainer(i);
	});
	if (videos[i].background_toggle) {
		bindVimeoBackgroundToggle(videos[i]);
	}

	Promise.all([
		videos[i].player.getVideoWidth(),
		videos[i].player.getVideoHeight(),
	]).then(function (dimensions) {
		var width = dimensions[0];
		var height = dimensions[1];
		var vid_container = videos[i].video_container_parent;

		vid_container.style.paddingTop = `calc(${height} / ${width} * 100%)`;
	});

	return videos[i].player;
}

function createAndWireYouTubePlayer(i) {
	return new Promise(function (resolve) {
		videos[i]["player"] = new YT.Player(videos[i].video_container, {
			videoId: videos[i].video_id,
			events: {
				onReady: function (event) {
					onPlayerReady(event, i);
					resolve(videos[i].player);
				},
				onStateChange: function (event) {
					onPlayerStateChange(event, i);
				},
			},
		});
	});
}

function bindVimeoBackgroundToggle(video) {
	var toggle = video.background_toggle;
	var mute = video.background_mute;
	var videoLabel = toggle.dataset.videoLabel || "video";
	var isMuted = true;

	var sync = function (isPaused) {
		toggle.classList.toggle("is-paused", isPaused);
		toggle.setAttribute("aria-pressed", isPaused ? "true" : "false");
		toggle.setAttribute(
			"aria-label",
			isPaused ? "Play " + videoLabel : "Pause " + videoLabel,
		);
	};

	var syncMute = function () {
		if (!mute) return;

		mute.classList.toggle("is-muted", isMuted);
		mute.setAttribute("aria-pressed", isMuted ? "true" : "false");
		mute.setAttribute(
			"aria-label",
			isMuted ? "Unmute " + videoLabel : "Mute " + videoLabel,
		);
	};

	video.player.on("play", function () {
		sync(false);
	});

	video.player.on("pause", function () {
		sync(true);
	});

	video.player.on("ended", function () {
		sync(true);
	});

	video.player.ready().then(function () {
		video.player.getPaused().then(sync);
	});

	toggle.addEventListener("click", function (event) {
		event.preventDefault();

		if (toggle.classList.contains("is-paused")) {
			video.player.play();
			return;
		}

		video.player.pause();
	});

	if (mute) {
		syncMute();
		mute.addEventListener("click", function (event) {
			event.preventDefault();

			isMuted = !isMuted;
			video.player.setMuted(isMuted);
			syncMute();
		});
	}
}

function playVimeoFromStart(player) {
	player.ready().then(function () {
		Promise.all([
			player.setCurrentTime(0),
			player.setLoop(false),
			player.setVolume(1),
			player.setMuted(false),
		]).then(function () {
			player.play();
		});
	});
}

function replaceVimeoPlayer(video) {
	var iframe = document.createElement("iframe");
	iframe.src = getVimeoEmbedUrl(video.video_id, false, true);
	iframe.setAttribute("frameborder", "0");
	iframe.setAttribute("allow", "autoplay; fullscreen; picture-in-picture");
	iframe.setAttribute("allowfullscreen", "");

	video.video_container.replaceChildren(iframe);

	return new Vimeo.Player(iframe);
}

function createVimeoPlayer(video, mutedPreview) {
	return new Vimeo.Player(video.video_container, {
		url: getVimeoEmbedUrl(video.video_id, mutedPreview, mutedPreview),
		autoplay: mutedPreview,
		autopause: false,
		background: false,
		byline: false,
		badge: false,
		chromecast: false,
		color: "a69167",
		controls: !mutedPreview,
		loop: mutedPreview,
		muted: mutedPreview,
		pip: false,
		portrait: false,
		sidedock: false,
		title: false,
		transcript: false,
		unmute_button: false,
		vimeo_logo: false,
		transparent: false,
	});
}

function getVimeoEmbedUrl(videoId, mutedPreview, autoplay) {
	var params = new URLSearchParams({
		autoplay: autoplay ? "1" : "0",
		autopause: "0",
		background: "0",
		byline: "0",
		chromecast: "0",
		color: "a69167",
		controls: mutedPreview ? "0" : "1",
		loop: mutedPreview ? "1" : "0",
		muted: mutedPreview ? "1" : "0",
		pip: "0",
		portrait: "0",
		sidedock: "0",
		title: "0",
		transcript: "0",
		unmute_button: "0",
		vimeo_logo: "0",
		transparent: "0",
	});

	return "https://player.vimeo.com/video/" + videoId + "?" + params.toString();
}

function onPlayerReady(event, key) {
	// Reset the container element
	// after the ready event has fired
	// and the div has changed to an iframe
	videos[key].video_container =
		videos[key].parent.querySelector(".video-container");
}

function onPlayerStateChange(event, key) {
	if (event.data === 0) {
		resetVideoContainer(key);
	}
}

function resetVideoContainer(key) {
	videos[key].parent.classList.remove("is-playing");
	videos[key].video_container.style.opacity = 0;
	videos[key].video_container.style.pointerEvents = "none";
	setTimeout(function () {
		if (videos[key].service == "youtube") {
			videos[key].player.stopVideo();
		} else if (videos[key].service == "vimeo") {
			videos[key].player.pause();
		}
	}, 1500);
}
